import React, { useEffect, useMemo, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "components/Common/TableContainer"
import eye from "../../assets/images/icons/eye.svg"
import { useNavigate, useParams } from "react-router-dom"
import { useLazyGetIcdRequestsByInvestorsQuery } from "store/api/icds/icdRequests.api"
import toast from "react-hot-toast"
import moment from "moment"
import IcdOffersDetailsModal from "./icdOffersDetails"
import {
  formatAmount,
  getIcdRequestStatus,
  getTableSortingHeaderIcon,
} from "helpers/common"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const ICDOffers = () => {
  const { id } = useParams()
  const history = useNavigate()
  const [getResults, { isFetching }] = useLazyGetIcdRequestsByInvestorsQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [icdData, setIcdData] = useState()
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [open, setOpen] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState()

  //meta title
  document.title = "ICD Requests - Prachay"

  const getList = async () => {
    try {
      const { data } = await getResults({ id, ...filters }).unwrap()
      setData(data.items.rows)
      setCount(data.items.count)
      setIcdData(data?.icd)
    } catch (error) {
      if (error.status === 404) {
        history("/icd/my-requests")
        toast.error(error?.data?.message, { id: "toastMessage" })
      }
    }
  }

  useEffect(() => {
    if (id) {
      getList()
    }
  }, [filters, id])

  const columns = useMemo(() => [
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
      accessorKey: "formatted_created_at",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Investor Detail",
      accessorKey: "name",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <DefaultAvatar
          avatar_url={row?.original.investor?.avatar_url}
          email={row?.original.investor?.email}
          name={row?.original.investor?.name}
        />
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Amount"),
      accessorKey: "unique_code",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="code-number">
          ₹ {formatAmount(row?.original.amount)}
        </div>
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, " Interest"),
      accessorKey: "interest_rate",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">{row?.original.interest_rate} %</div>
      ),
    },

    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, "Date of Repayment"),
      accessorKey: "repayment_date",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">
          {row?.original.repayment_date
            ? moment(row?.original.repayment_date).format("D MMM YYYY")
            : ""}
        </div>
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Status"),
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="code-status">
          {getIcdRequestStatus(row?.original.status)}
        </div>
      ),
    },
    {
      header: "Action",
      id: "action",
      cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center gap-3">
          <div className="action-view">
            {/* <Link to={"/icd/view"}> */}
            <img
              src={eye}
              alt=""
              onClick={() => {
                setSelectedRequest(row?.original)
                setOpen(true)
              }}
            />
            {/* </Link> */}
          </div>
        </div>
      ),
    },
  ])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={
              <>
                ICD Request <>( {icdData?.unique_code} ) </>
              </>
            }
          />
          <TableContainer
            isLoading={isFetching}
            count={count}
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            data={data}
            isGlobalFilter={false}
            isCustomPageSize={false}
            // isGlobalFilter={true}
            isPagination={true}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </Container>
      </div>
      <IcdOffersDetailsModal
        icdData={icdData}
        requestData={selectedRequest}
        open={open}
        setOpen={setOpen}
        accepted={() => {
          setOpen(false)
          setFilters((prev) => ({
            ...prev,
            page: 1,
            timestamp: moment().unix(),
          }))
        }}
        rejected={() => {
          setOpen(false)
          setFilters((prev) => ({
            ...prev,
            page: 1,
            timestamp: moment().unix(),
          }))
        }}
      />
    </React.Fragment>
  )
}

export default ICDOffers
